import React, { Component } from 'react'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import './pdf.scss'
import EventBus from '../common/EventBus.js'
import $ from 'jquery'
import ProposalContent from "./content.component.jsx";
const queryString = require('query-string')

const Debug = false
let pageSize = 1150
let pageSizeType = "letter"

class ProposalPdf extends Component {

    constructor(props, context) {
        super(props, context)

        let pageSizeIsParameter = false
        let pageSizeTypeIsParameter = false
        const uri = queryString.parse(location.search)
        if (uri.pageSize) {
            pageSize = uri.pageSize
            pageSizeIsParameter = true
        }
        if (uri.pageSizeType) {
            pageSizeType = uri.pageSizeType
            pageSizeTypeIsParameter = true
        }

        this.state = {
            proposal: null,
            options: [],
            showApprovedMessage: false,
            pageSizeIsParameter,
            pageSizeTypeIsParameter,
        }
    }

    getPageStyle() {
        switch (pageSizeType) {
            case 'letter': return `@page {margin:0 0 0 0; padding:0 0 0 0; size:letter;}`
            case 'a4':
            case 'A4': return `@page {margin:0 0 0 0; padding:0 0 0 0; size:A4;}`
            default: return `@page {margin:0 0 0 0; padding:0 0 0 0; size:${pageSizeType};}`
        }
    }

    setPageSize(pageSizeType) {
        switch (pageSizeType) {
            case 'letter': pageSize = 1150
                break
            case 'a4':
            case 'A4': pageSize = 1300
                break
            default: pageSize = 1150
        }
    }

    componentDidMount() {
        AppContext.getApiClient().get('/proposals/' + this.props.match.params.hash).then(res => {
            EventBus.dispatch(EventBus.TopicLocaleChange, {
                locale: res.attributes.variables.global.language,
            })

            if (!this.state.pageSizeTypeIsParameter && res.attributes.pageSize) {
                pageSizeType = res.attributes.pageSize
            }
            if (!this.state.pageSizeIsParameter) {
                this.setPageSize(pageSizeType)
            }

            this.setState({
                proposal: res.attributes.variables,
                conversionDelayInSeconds: res.attributes.pdfConversionDelay,
            }, () => {

                let pageNumber = 0
                let currentPageSpace = pageSize
                let timeout = this.state.conversionDelayInSeconds * 1000 - 2000
                if (timeout <= 0) {
                    timeout = 1500
                }

                setTimeout(() => {
                    window.scrollTo(0, 0)
                    const pages = []
                    let currentPage = []
                    let lastElement = null
                    $('.section-size').each((index, element) => {
                        if (Debug) {
                            $(element).append('<div class="section-size-debug">' + element.offsetHeight + 'px</div>')
                        }
                        // Don't add separator at the beginning of a page
                        if (!$(element).hasClass('separator') || currentPage.length > 0) {
                            if (element.offsetHeight < currentPageSpace) {
                                currentPageSpace -= element.offsetHeight
                                currentPage.push(element.outerHTML)
                            } else {
                                if (lastElement && $(lastElement).hasClass('separator')) {
                                    currentPage.pop()
                                }
                                pages.push(currentPage)
                                currentPage = []
                                pageNumber++
                                currentPageSpace = pageSize - element.offsetHeight
                                currentPage.push(element.outerHTML)
                            }
                        }
                        lastElement = element

                    })
                    if (currentPage.length > 0) {
                        pages.push(currentPage)
                    }

                    $('#proposal-content').html('')
                    for (let i in pages) {
                        $('#proposal-content').append('<div class="row page-break-after pt-3 px-2">' +
                            '<div class="ui-module-proposal-no-border col-12">' +
                            pages[i].join('') +
                            '</div>' +
                            '</div>')
                    }

                }, timeout)

            })
        })
    }

    render() {
        if (!this.state.proposal) {
            return <LoadingSpinner marginTop="20px" />
        }
        var showBranding=this.state.proposal.global.hasBranding
        return <div>
            <style>
                {`@media print {body {margin:0 0 0 0; padding:0 0 0 0;}}`}
            </style>
            <style>
                {this.getPageStyle()}
            </style>
            <div className="container-fluid pdf-document pt-0 px-3">
                <ProposalContent showBranding={showBranding} variables={this.state.proposal} editable={false} isPdf={true} />
            </div>
        </div>
    }

}

export default ProposalPdf





// WEBPACK FOOTER //
// ./src/proposal/pdf.component.jsx